class RequestABrochure {
  constructor() {
    this.cookieName = "brochureSubmitted";
    this.brochureElementSelectors = [
      '.brochure-content-square',
      '.brochure_form',
    ];
    this.brochureElements = document.querySelectorAll(this.brochureElementSelectors.join(','));
  }

  init() {
    const brochureCookie = this.getCookie(this.cookieName)

    if(brochureCookie == "true" || brochureCookie == true) {
      this.hideBrochureElements();

      let brochureNotifications = document.querySelectorAll('.brochure-notifications');

      if(brochureNotifications.length > 0) {
        brochureNotifications.forEach(function (notification) {
          notification.classList.add('is-visible');

          notification.querySelector('.c-notification--already-submitted')?.classList.add('is-visible');
        });
      }
    }
  }

  resetCookie() {
    this.setCookie(this.cookieName, '', -1);
  }

  getCookie(key) {
    let name = `${key}=`;
    let decodedCookie = decodeURIComponent(document.cookie);
    let cookies = decodedCookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i];

      while (cookie.charAt(0) == ' ') {
        cookie = cookie.substring(1);
      }

      if (cookie.indexOf(name) == 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }

    return false;
  }

  hideBrochureElements() {

    if (this.brochureElements.length > 0) {
      this.brochureElements.forEach(function (element) {
        element.classList.add('hidden');
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  let requestABrochure = new RequestABrochure();
  requestABrochure.init();
});